import React from 'react';

function CoachesAndTrackSlider() {
  return (
    <div className="image-slide-block test-a-slide no-absolute tp-0">
      <img
        src="/static/newLandingPageContent/images/Aura-1111.png"
        loading="lazy"
        sizes="(max-width: 479px) 371px, (max-width: 767px) 462px, (max-width: 991px) 558.59375px, (max-width: 1919px) 638.390625px, 33vw"
        srcSet="/static/newLandingPageContent/images/Aura-1111-p-500.png 500w, /static/newLandingPageContent/images/Aura-1111-p-800.png 800w, /static/newLandingPageContent/images/Aura-1111-p-1080.png 1080w, /static/newLandingPageContent/images/Aura-1111.png 1308w"
        alt=""
        className="image-slide-1 splited-img"
      />
      <img
        src="/static/newLandingPageContent/images/Aura-2nd.png"
        loading="lazy"
        sizes="(max-width: 479px) 371px, (max-width: 767px) 462px, (max-width: 991px) 558.59375px, (max-width: 1919px) 638.390625px, 33vw"
        srcSet="/static/newLandingPageContent/images/Aura-2nd-p-500.png 500w, /static/newLandingPageContent/images/Aura-2nd-p-800.png 800w, /static/newLandingPageContent/images/Aura-2nd-p-1080.png 1080w, /static/newLandingPageContent/images/Aura-2nd.png 1308w"
        alt=""
        className="image-slide-1 splited-img"
      />
      <img
        src="/static/newLandingPageContent/images/3rd.png"
        loading="lazy"
        sizes="(max-width: 479px) 371px, (max-width: 767px) 462px, (max-width: 991px) 558.59375px, (max-width: 1919px) 638.390625px, 33vw"
        srcSet="/static/newLandingPageContent/images/3rd-p-500.png 500w, /static/newLandingPageContent/images/3rd-p-800.png 800w, /static/newLandingPageContent/images/3rd-p-1080.png 1080w, /static/newLandingPageContent/images/3rd.png 1314w"
        alt=""
        className="image-slide-1 splited-img"
      />
      <img
        src="/static/newLandingPageContent/images/4th.png"
        loading="lazy"
        sizes="(max-width: 479px) 371px, (max-width: 767px) 462px, (max-width: 991px) 558.59375px, (max-width: 1919px) 638.390625px, 33vw"
        srcSet="/static/newLandingPageContent/images/4th-p-500.png 500w, /static/newLandingPageContent/images/4th-p-800.png 800w, /static/newLandingPageContent/images/4th-p-1080.png 1080w, /static/newLandingPageContent/images/4th.png 1296w"
        alt=""
        className="image-slide-1 splited-img"
      />
      <img
        src="/static/newLandingPageContent/images/Aura-1111.png"
        loading="lazy"
        sizes="(max-width: 479px) 371px, (max-width: 767px) 462px, (max-width: 991px) 558.59375px, (max-width: 1919px) 638.390625px, 33vw"
        srcSet="/static/newLandingPageContent/images/Aura-1111-p-500.png 500w, /static/newLandingPageContent/images/Aura-1111-p-800.png 800w, /static/newLandingPageContent/images/Aura-1111-p-1080.png 1080w, /static/newLandingPageContent/images/Aura-1111.png 1308w"
        alt=""
        className="image-slide-1 splited-img"
      />
      <img
        src="/static/newLandingPageContent/images/Aura-2nd.png"
        loading="lazy"
        sizes="(max-width: 479px) 371px, (max-width: 767px) 462px, (max-width: 991px) 558.59375px, (max-width: 1919px) 638.390625px, 33vw"
        srcSet="/static/newLandingPageContent/images/Aura-2nd-p-500.png 500w, /static/newLandingPageContent/images/Aura-2nd-p-800.png 800w, /static/newLandingPageContent/images/Aura-2nd-p-1080.png 1080w, /static/newLandingPageContent/images/Aura-2nd.png 1308w"
        alt=""
        className="image-slide-1 splited-img"
      />
      <img
        src="/static/newLandingPageContent/images/3rd.png"
        loading="lazy"
        sizes="(max-width: 479px) 371px, (max-width: 767px) 462px, (max-width: 991px) 558.59375px, (max-width: 1919px) 638.390625px, 33vw"
        srcSet="/static/newLandingPageContent/images/3rd-p-500.png 500w, /static/newLandingPageContent/images/3rd-p-800.png 800w, /static/newLandingPageContent/images/3rd-p-1080.png 1080w, /static/newLandingPageContent/images/3rd.png 1314w"
        alt=""
        className="image-slide-1 splited-img"
      />
      <img
        src="/static/newLandingPageContent/images/4th.png"
        loading="lazy"
        sizes="(max-width: 479px) 371px, (max-width: 767px) 462px, (max-width: 991px) 558.59375px, (max-width: 1919px) 638.390625px, 33vw"
        srcSet="/static/newLandingPageContent/images/4th-p-500.png 500w, /static/newLandingPageContent/images/4th-p-800.png 800w, /static/newLandingPageContent/images/4th-p-1080.png 1080w, /static/newLandingPageContent/images/4th.png 1296w"
        alt=""
        className="image-slide-1 splited-img"
      />
    </div>
  );
}

export default CoachesAndTrackSlider;
